import React from 'react';
import { Select, Spin, Button, Icon, Modal, Form, Input, Row, Col } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogosRequest from '../../services/Catalogos';
import CategoriasRequest from '../../services/Categorias';
import BaseComponent from '../Common/BaseComponent';

const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de formulario de categorizar
 */
class FormCategorias extends BaseComponent {
    state = {
        arrCategorias: [],
        arrArticulosCategorizar: [],
        guardando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrTiposModelos: [],
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.tipo_modal === 'uno') {
            if ((this.props.detalleCategoria !== prevProps.detalleCategoria)) {
                if (!state.arrTiposModelos.length) {
                    CatalogosRequest.ListarTiposModelos()
                        .then(response => {
                            state.arrTiposModelos = response.data;
                            this.setState(state)
                        })
                        .catch(err => {
                            openNotification(
                                "Ha ocurrido un error al listar los tipos de modelos.",
                                "Error al listar tipos de modelos",
                                false
                            )
                        })
                }

            }
        } else {
            if (!state.arrTiposModelos.length) {
                CatalogosRequest.ListarTiposModelos()
                    .then(response => {
                        state.arrTiposModelos = response.data;
                        this.setState(state)
                    })
                    .catch(err => {
                        openNotification(
                            "Ha ocurrido un error al listar los tipos de modelos.",
                            "Error al listar tipos de modelos",
                            false
                        )
                    })
            }
        }
    }

    /**
     * Comportamiento all hacer clic en categorizar artículos
     * @param: nada.
     * @return: nada.
     */
    editarCategoria = () => {
        let state = { ...this.state }
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let id_categoria = null;
                if (this.props.detalleCategoria !== undefined) {
                    if (this.props.detalleCategoria !== null) {
                        id_categoria = this.props.detalleCategoria.id
                    }
                }
                let objEnviar = {
                    descripcion: values.nombreCategoria,
                    tipo_modelo: values.tipoModelo
                }
                CategoriasRequest.EditarCategoria(id_categoria, objEnviar)
                    .then(response => {
                        state.guardando = false;
                        state.bloquearBotones = false;
                        this.props.form.resetFields();
                        this.props.esconderModal(true);
                        this.setState(state)
                        let titulo = 'creada'
                        let mensaje = 'creado'
                        if(this.props.tipo_modal === 'uno'){
                            titulo = 'editada'
                            mensaje = 'editado'
                        }
                        openNotification(
                            `Se ha ${mensaje} la categoría correctamente.`,
                            `Categoría ${titulo} correctamente`,
                            true
                        )
                    })
                    .catch(err => {
                        this.setState({ guardando: false, bloquearBotones: false })
                        openNotification(
                            "Ha ocurrido un error al editar la categoría.",
                            "Error al editar categoría",
                            false
                        )
                    })
            }
        })
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);
        this.setState({ bloquearBotones: false })
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.props.tipo_modal === 'uno') {
                    confirm({
                        title: 'Confirmar',
                        content: <div><b>¿Está seguro de editar la categoría?</b> Se cambiará la información de la categoría.</div>,
                        okText: 'Aceptar',
                        cancelText: 'Cancelar',
                        okButtonProps: {
                            id: 'boton-aceptar-confirmacion-categoria-form',
                        },
                        cancelButtonProps: {
                            id: 'boton-cancelar-confirmacion-categoria-form',
                        },
                        onOk: () => {
                            this.setState({ guardando: true, bloquearBotones: true }, this.editarCategoria())
                        },
                    });
                } else {
                    this.setState({ guardando: true, bloquearBotones: true }, this.editarCategoria())
                }
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Modal
                    title={this.props.modo === 'ver' ? 'Ver detalle de categoría' : this.props.modo === 'editar' ? 'Editar categoría' : 'Nueva categoría'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.categorizarArts}
                    width={this.state.isPos ? "80%" : "35%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-categorias-form"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-categorias-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Nombre de categoría" : <b>Nombre de categoría</b>}
                                        colon={(this.props.modo !== "ver" ? true : false)}>
                                        {getFieldDecorator('nombreCategoria', {
                                            rules: [
                                                { transform: value => { return value ? value.trim() : value }, type: "string" },
                                                { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, ingrese nombre de categoría.' },
                                                { min: 2, message: "El nombre debe tener más de 2 caracteres." },
                                                { max: 125, message: "Ha exedido el límite máximo de 125 caracteres." },
                                                { whitespace: true, message: 'Por favor, ingrese nombre de categoría.' }
                                            ],
                                            initialValue: (
                                                (this.props.detalleCategoria !== undefined && this.props.detalleCategoria !== null) ? this.props.detalleCategoria.descripcion : null
                                            )
                                        })(
                                            <Input
                                                style={{ width: "100%" }}
                                                id="input-nombre-categoria-form"
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                placeholder="Ingrese nombre de categoría"
                                            />,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Tipo de modelo" : <b>Tipo de modelo</b>}
                                        colon={(this.props.modo !== "ver" ? true : false)}>
                                        {getFieldDecorator('tipoModelo', {
                                            rules: [
                                                { required: this.props.modo !== "ver" ? true : false, message: 'Por favor, seleccione un tipo de modelo.' },
                                            ],
                                            initialValue: (
                                                (this.props.detalleCategoria !== undefined && this.props.detalleCategoria !== null) ? this.props.detalleCategoria.tipo_modelo : null
                                            )
                                        })(
                                            <Select
                                                allowClear={this.props.modo !== "ver" ? true : false}
                                                style={{ width: '100%' }}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                showSearch
                                                maxLength={100}
                                                showArrow={this.props.modo !== "ver"}
                                                className={this.props.modo !== "ver" ? '' : 'disableInput'}
                                                disabled={this.props.modo !== "ver" ? false : true}
                                                id="select-elegir-tipo-modelo-form"
                                                defaultActiveFirstOption={false}
                                                optionFilterProp="children"
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    this.state.arrTiposModelos.length > 0 &&
                                                    this.state.arrTiposModelos.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.id}
                                                                value={obj.id}>
                                                                {obj.descripcion}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormCategorias);